import { isPlatformBrowser } from "@angular/common";
import { Component, inject, OnInit, PLATFORM_ID } from "@angular/core";

export const FORGOT_PASSWORD_FAILURE = 'forgot password failure';

@Component({
    selector: 'app-forgot-password-failure-callback',
    template: '<h1>Redirecting... Please wait</h1>'
})
export class ForgotPasswordFailureCallbackComponent implements OnInit {
    private readonly platformId = inject(PLATFORM_ID);
    ngOnInit(): void {
        if (isPlatformBrowser(this.platformId)) {
            window.parent.postMessage(FORGOT_PASSWORD_FAILURE);
        }
    }
}